import { useTranslation } from "react-i18next";
import { CardTitle, typography } from "@dsaui/components";
import { InformationCircle } from "@dsaui/icons";
import { cn } from "packages/dsaui/src/utils";

interface SignupIntroProps {
  onSignInClick: () => void;
}

export const SignupIntro = ({ onSignInClick }: SignupIntroProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 px-4 py-6 sm:px-6 sm:py-8">
      <div className="mx-auto w-full max-w-2xl">
        <div className="flex flex-col items-center gap-2 text-center">
          <CardTitle className={cn(typography.formPageTitle.className, "text-balance")}>
            {t("signup.page.title")}
          </CardTitle>
          <p className={cn(typography.formSubtitle.className, "text-center")}>
            {t("signup.page.or")}{" "}
            <button
              onClick={onSignInClick}
              className={cn(
                typography.formLink.className,
                "cursor-pointer border-0 bg-transparent p-0 font-medium no-underline",
              )}
              type="button"
            >
              {t("signup.page.signInLink")}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export const SignupSuccess = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-start gap-4 rounded-xl bg-green-50 px-6 py-7 text-left text-green-900"
      role="status"
    >
      <div className="shrink-0 text-green-600">
        <InformationCircle className="size-7" />
      </div>
      <div className="min-w-0">
        <p className="m-0 text-lg leading-7 font-semibold text-green-900">
          {t("signup.success.title")}
        </p>
        <p className="mt-2 mb-0 text-base leading-6 font-normal text-green-900">
          {t("signup.success.body")}
        </p>
      </div>
    </div>
  );
};
